import { render, staticRenderFns } from "./CampaignTable.vue?vue&type=template&id=c8f13a2c"
import script from "./CampaignTable.vue?vue&type=script&lang=ts"
export * from "./CampaignTable.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports